import React, {Component} from 'react';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Home from './Components/Home/Home';

export default class App extends Component {
    componentWillMount = () => {
        const mouse1 = document.createElement('div');
        const mouse2 = document.createElement('div');
        mouse1.className = 'mouse1';
        mouse2.className = 'mouse2';
        document.body.appendChild(mouse1);
        document.body.appendChild(mouse2);
        document.addEventListener('mousemove', (e) => {
            mouse1.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
            mouse2.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
        });
    }

    render() {
        return (
            <Router>
                <Switch>
                    <Route path="/">
                        <Home />
                    </Route>

                </Switch>
            </Router>
        );
    }
}

